export const it = {
  // Common
  conversation: 'Conversazione',
  connected: 'Connesso',
  disconnected: 'Disconnesso',
  loading: 'Caricamento...',
  error: 'Errore',
  
  // Welcome messages
  welcomeMessage: 'Ciao, come posso aiutarti oggi?',
  joinedChat: 'si è unito alla chat',
  
  // Chat actions
  createNewChat: 'Crea una nuova conversazione',
  newConversation: 'Nuova conversazione',
  moreResults: 'Voglio più risultati',
  
  // Input placeholders
  inputPlaceholder: 'Scrivi un messaggio...',
  inputPlaceholderGenerating: 'Generazione risultati...',
  
  // Loading messages
  collectingInfo: 'Raccogliendo informazioni necessarie ...',
  searchingBestResults: 'Cercando i migliori risultati ...',
  analyzingDatabase: 'Analizzando database per la ricerca ...',
  checkingSpecialOffers: 'Verificando offerte speciali disponibili ...',
  searchingSimilarProducts: 'Cercando prodotti simili ...',
  preparingRecommendations: 'Preparando raccomandazioni personalizzate ...',
  checkingStock: 'Verificando scorte e disponibilità prodotti ...',
  finalizingResponse: 'Finalizzando risposta con le opzioni più rilevanti ...',
  
  // Thinking steps
  analyzingRequest: 'Analizzando la tua richiesta ...',
  generatingSearchTerms: 'Generando termini di ricerca ...',
  processingSearchTerms: 'Elaborando termini di ricerca ...',
  searchingDatabase: 'Cercando nel database prodotti adatti ...',
  processingResults: 'Elaborando risultati trovati ...',
  generatingEstimates: 'Generando stime di tempo e costo ...',
  generatingFinalResponse: 'Generando risposta finale ...',
  processingRequest: 'Findly sta pensando ...',
  
  // Status messages
  waitingPreviousResults: 'Aspettando risultati conversazione precedente ...',
  checkingContinuation: 'Verificando se la conversazione può continuare...',
  
  // Empty states
  noMessagesYet: 'Nessun messaggio ancora',
  
  // Error messages
  failedCreateChat: 'Impossibile creare una nuova chat. Riprova.',
  errorCreatingChat: 'Errore nella creazione della chat',
  errorSendingMessage: 'Errore nell\'invio del messaggio',
  errorLoadingChats: 'Errore nel caricamento delle chat',
  
  // Cart messages
  productAddedToCart: 'Il prodotto {{productCode}} è stato aggiunto al carrello!',
  
  // Chat titles
  defaultChatTitle: 'Chat {{timestamp}}',
  
  // Connection status
  connectionStatusConnected: 'Connesso 🟢',
  connectionStatusDisconnected: 'Disconnesso 🔴',

  // Chat encouragement messages (cycled every 5 seconds)
  chatEncouragement1: 'Posso aiutarti a trovare i prodotti che stai cercando!',
  chatEncouragement2: 'Hai bisogno di aiuto per trovare qualcosa di specifico?',
  chatEncouragement3: 'Lascia che ti assista con i tuoi acquisti!'
};
